import { Component, ElementRef, inject, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { StringUtils } from "@arch/_shared/utils";
import { EventsService } from "@arch/domain/application/services/events.service";
import { ReportEntity } from "@arch/domain/entity/report.entity";
import { VisualizationEntity } from "@arch/domain/entity/visualization.entity";
import { UpdateReportVisualizationsVisibleController } from "@arch/presentation/controllers";
import _ from "lodash";

@Component({
    selector: "app-edit-visible-indicators",
    imports: [SharedMaterialModule, SharedDsnModule, FormsModule],
    templateUrl: "./edit-visible-indicators.component.html",
    styleUrl: "./edit-visible-indicators.component.scss"
})
export class EditVisibleIndicatorsComponent implements OnInit {
    public readonly data = inject<{
        report: ReportEntity;
    }>(MAT_DIALOG_DATA);
    public readonly dialogRef =
        inject<MatDialogRef<EditVisibleIndicatorsComponent>>(MatDialogRef);

    private readonly eventsService = inject(EventsService);

    private readonly updateReportVisualizationsVisibleController = inject(
        UpdateReportVisualizationsVisibleController
    );

    public loading = false;
    public reportName = "";
    public reportNameInput: ElementRef<HTMLInputElement>;
    public visualizationNameFilter = "";
    public filteredVisualizations: VisualizationEntity[] = [];
    public visibleVisualizations: { _id: string; visible: boolean }[] = [];

    ngOnInit(): void {
        this.reportName = structuredClone(this.data.report.props.name);
        this.filteredVisualizations = _.cloneDeep(
            this.data.report.visualizations.visualzations
        );
        this.visibleVisualizations = _.cloneDeep(
            this.data.report.visibleVisualizations
        );
    }

    public onSaveChanges(): void {
        this.data.report.visibleVisualizations = this.visibleVisualizations;
        this.data.report.name = this.reportName;
        this.updateReportVisualizationsVisibleController.execute(
            this.data.report
        );
        this.eventsService.send(`Dash.Editou.Indicadores`);
        this.dialogRef.close(this.visibleVisualizations);
    }

    public onEditReportName(): void {
        this.reportNameInput?.nativeElement?.focus();
    }

    public onVisualizationNameFilterChange(value: string): void {
        this.visualizationNameFilter = value;
        this.filteredVisualizations =
            this.data.report.visualizations.visualzations.filter(
                (visualization) =>
                    StringUtils.normalizeND(visualization.props.name).includes(
                        StringUtils.normalizeND(value)
                    )
            );
    }

    public isVisible(visualization: VisualizationEntity): boolean {
        return this.visibleVisualizations.find(
            (v) => v._id === visualization.props._id
        )?.visible;
    }

    public onCheckboxValueChange(visualization: VisualizationEntity): void {
        const visibleVisualization = this.visibleVisualizations.find(
            (v) => v._id === visualization.props._id
        );
        if (visibleVisualization?.visible) {
            visibleVisualization.visible = false;
        } else {
            visibleVisualization.visible = true;
        }
    }
}
